import {useCallback, useState} from 'react';

import styled from 'styled-components';

import CustomTableRow from './CustomTableRow';

const CustomTableBodyStyled = styled.tbody`
  background: ${({theme}) => theme.userReport.general.background};

  & > *:last-child {
    border-bottom: none;
  }
`;

const CustomTableBody = props => {
  const {columns, rows, toggleRow, menuEvents} = props;
  const [openedRowMenuId, setOpenedRowMenuId] = useState();

  const onMenuClick = useCallback(
    rowId => {
      if (openedRowMenuId === rowId || !rowId) {
        setOpenedRowMenuId(null);
      } else {
        setOpenedRowMenuId(rowId);
      }
    },
    [openedRowMenuId],
  );
  return (
    <CustomTableBodyStyled>
      {rows?.map(
        (row, index) =>
          !row.isTotalAmountRow && (
            <CustomTableRow
              // eslint-disable-next-line react/no-array-index-key
              key={`custom_table_row_${index}`}
              index={index}
              onMenuClick={onMenuClick}
              columns={columns}
              rowData={row}
              openedRowMenuId={openedRowMenuId}
              role="columnheader"
              toggleRow={toggleRow}
              menuEvents={menuEvents}
              {...props}
            />
          ),
      )}
    </CustomTableBodyStyled>
  );
};

export default CustomTableBody;
